import { Placeholder } from './Placeholder';

interface Props {
  src?: string | null;
  alt: string;
  placeholder: string;
}

export function ReferenceImage({ src, alt, placeholder }: Props) {
  if (!src) {
    return <Placeholder text={placeholder} />;
  }
  return (
    <img
      src={src}
      alt={alt}
      className="bg-onlight-bg-2 dark:bg-ondark-bg-2 h-full w-full object-contain"
    />
  );
}

export default ReferenceImage;
